import { ButtonModule } from 'primeng/button';
import { Component } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { ReportsServicesService } from '../../../services/reports-services.service';
import { DevicesService } from '../../../services/devices.service';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { Device } from '../../../models/device';
import { LoaderComponent } from "../../../utils/loader/loader.component";
import { DatepickerComponent } from "../../../utils/datepicker/datepicker.component";
import { CustomTableComponent } from "../../../utils/custom-table/custom-table.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'app-qrs',
    imports: [ButtonModule, LoaderComponent, DatepickerComponent, CustomTableComponent, FormsModule, InputTextModule, SelectModule, CommonModule],
    templateUrl: './qrs.component.html',
    styleUrl: './qrs.component.scss'
})
export class QrsComponent {
  data:any;
devices:any=[]=[];
generatedCodes:any[]=[];
isLoading=false;
fromDate!: Date;
  toDate!: Date;
  photos: any[] = [];
  selectedCard=-1;
  showModalContent = false;
  isSignature = false;
  fromDateRequest!: Date;
  toDateRequest!: Date;

  allDevices: any[] = [
    {
      value:-1,
       text:'Todos'
    }
  ];

public pagTickets: PaginationInstance = {
    id: 'idPag',
    itemsPerPage: 8,
    currentPage: 1
  };

  statusList:any[]= [
    {
      status:'ACTIVO',
      style:'bg-lime-100 text-lime-800'
    },
    {
      status:'EN PROCESO',
      style:'bg-yellow-100 text-yellow-800'
    },
    {
      status:'USADO',
      style:'bg-blue-100 text-blue-800'
    },
    {
      status:'CANCELADO',
      style:'bg-red-100 text-red-800'
    },
    {
      status:'EXPIRADO',
      style:'bg-zinc-200 text-zinc-800'
    }
  ];

  headers: any[] = [
    
    { key: "folio", textHeader: "Folio QR", visible: true, type: "string" },
    { key: "card", textHeader: "No. Tarjeta", visible: true, type: "string" },
    { key: 'statusDesc', textHeader: 'Status', visible: true,type: "status"  },
    { key: "creationDate", textHeader: "Fecha de creación", visible: true, type: "date" },
    { key: "expirationDate", textHeader: "Fecha de expiración", visible: true, type: "date" },
    { key: "amountRequested", textHeader: "Monto solicitado", visible: true, type: "currency" },
    { key: "amountServed", textHeader: "Monto cargado", visible: true, type: "currency" },
    { key: "quantityRequested", textHeader: "Cantidad solicitada", visible: true, type: "liters" },
    { key: "quantityServed", textHeader: "Cantidad cargada", visible: true, type: "liters" },
    { key: "description", textHeader: "Descripción", visible: true, type: "string" },
    { key: "comments", textHeader: "Comentario", visible: true, type: "string" },
   

  ];


  constructor(private service: ReportsServicesService, private deviceService: DevicesService, private titleService: Title, private themeService: ThemeService
  
    ) {
      this.titleService.setTitle("Reporte - QR");
      this.themeService.setTitle("Reporte de QR Generados");
      this.data = JSON.parse(localStorage.getItem('data')!);
  
    }
  
    ngOnInit() {
      //this.isRedcoClient = this.data.IsredcoClient.toLowerCase() === 'true';
      //this.getStations();
      this.getAllCards();
    }
    setDatesOnFilter(event: any) {
      this.fromDate = event.from;
      this.toDate = event.to;
    }

    changeDeviceFilter(event:any){
      this.selectedCard = event.value;
    }
  
    search() {
      this.isLoading = true;
      this.fromDateRequest = new Date(this.fromDate);
      this.toDateRequest = new Date(this.toDate);
      this.pagTickets.currentPage = 1;
      this.service.getQRsClient(this.data.Client_number, this.fromDateRequest, this.toDateRequest, this.selectedCard).subscribe({
        next: (resp: any) => {
          this.generatedCodes = resp;
          this.isLoading = false;
        },
        error: (err: any) => {
          this.generatedCodes =[];
          this.isLoading = false;
        }
      });
    }


     getAllCards() {

    this.deviceService.loadDevices(this.data.Client_number, this.data.User_id, '', true).subscribe({
      next: (resp: any) => {
        resp.forEach((element: any) => {
          this.allDevices.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          });
          
        });

      },
      error: (error: any) => {
        this.allDevices = [];

      }

    })
  }

    clickOutside(isOut: any) {
    if (isOut) {
      this.showModalContent = false;
    }
  }
  
    
  
    

}
